import React from "react";

const Logo = ({ size = 30, className = "", testId = "indoblitz-logo" }) => (
    <div className={`flex items-center ${className}`} data-testid={testId}>
        <img
            src="/indoblitz-logo.png"
            alt="IndoBlitz - Crafting Young Minds"
            style={{ height: size, width: "auto", objectFit: "contain", display: "block" }}
            className="select-none pointer-events-none"
            draggable={false}
        />
    </div>
);

export default Logo;
